import React from 'react';

import { Box } from '@mui/material';

import { ICON_COLORS } from '../Note.constants';

import type { NoteVariant } from '../Note.types';

type NoteStatusIconProperties = {
  variant: NoteVariant;
};

export const NoteStatusIcon: React.FC<NoteStatusIconProperties> = ({
  variant,
}) => (
  <Box
    sx={{
      width: 18,
      height: 18,
      borderRadius: '50%',
      backgroundColor: ICON_COLORS[variant],
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      mt: 0.25,
    }}
  >
    <Box
      sx={{
        width: 6,
        height: 6,
        borderRadius: '50%',
        backgroundColor: 'common.white',
      }}
    />
  </Box>
);
